import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertCircle } from 'lucide-react';

interface MissedQuestionsNotificationProps {
  show: boolean;
  categoryTitle: string;
  missedCount: number;
  onClose: () => void;
}

const MissedQuestionsNotification: React.FC<MissedQuestionsNotificationProps> = ({
  show,
  categoryTitle,
  missedCount,
  onClose
}) => {
  React.useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="fixed top-4 right-4 z-50"
        >
          <div className="bg-warning-50 border border-warning-200 rounded-lg shadow-lg p-4 max-w-md">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <AlertCircle className="h-5 w-5 text-warning-500" />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-warning-800">
                  Missed Questions
                </h3>
                <div className="mt-1 text-sm text-warning-700">
                  You have {missedCount} unanswered {missedCount === 1 ? 'question' : 'questions'} in the {categoryTitle} category.
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MissedQuestionsNotification;